































import {Vue, Component, Prop} from 'vue-property-decorator';
import Tag from './Tag.vue';
import ContentItem from './ContentItem.vue';
import {namespace} from 'vuex-class';
const termsModule = namespace('terms');

@Component({
  components: {
    Tag,
    ContentItem
  }
})
export default class NcpLayerPopup extends Vue {
  //eg: [{tag, tagItems: [{style, value}, [{style, value}, [{style, value}...]}...]
  @Prop({
    required: false,
    default: function() {
      return {};
    }
  })
  private popInfo?: {};

  @termsModule.Mutation('SET_NCPLAYERISSHOW') private setIsShow!: (isExist: boolean) => void;
}
